import { GcpErrorReporter } from "@kaggle/core";
import { featureFlags, getSessionClaims, getSessionTokenFromCookie } from "@kaggle/sdk";
var errorReporter;
function isErrorReporterDisabled() {
    return !featureFlags.frontendErrorReporting || process.env.NODE_ENV === "development";
}
function getErrorSampleRate() {
    var errorSampleRate = Number(featureFlags.frontendErrorReportingSampleRate);
    if (isNaN(errorSampleRate) || errorSampleRate > 1 || errorSampleRate < 0) {
        return undefined;
    }
    return errorSampleRate;
}
export function startErrorReporter(versionModifier) {
    if (isErrorReporterDisabled()) {
        return;
    }
    var sessionClaims = getSessionClaims(getSessionTokenFromCookie());
    if (sessionClaims) {
        try {
            var ref2;
            var ref1;
            var gcpErrorReporter = new GcpErrorReporter({
                key: sessionClaims.sdak,
                projectId: sessionClaims.pid,
                service: sessionClaims.svc,
                version: versionModifier ? "ci-".concat(versionModifier) : "ci",
                userId: (ref1 = (ref2 = sessionClaims.uid) === null || ref2 === void 0 ? void 0 : ref2.toString()) !== null && ref1 !== void 0 ? ref1 : "",
                sampleRate: getErrorSampleRate()
            });
            gcpErrorReporter.startReportingUncaughtErrors();
            gcpErrorReporter.startReportingUnhandledPromiseRejections();
            if (featureFlags.frontendConsoleErrorReporting) {
                gcpErrorReporter.startReportingConsoleErrorLogging();
            }
            errorReporter = gcpErrorReporter;
        } catch (err) {
            // tslint:disable-next-line:no-console
            console.error("Failed to start Stackdriver Error Reporter: " + err);
        }
    } else {
        // tslint:disable-next-line:no-console
        errorReporter = {
            report: console.error
        };
    }
}
export function getErrorReporter() {
    if (isErrorReporterDisabled()) {
        return null;
    }
    if (!errorReporter) {
        startErrorReporter();
    }
    return errorReporter;
}
var ref;
/** Shorthand for reporting errors. */ export var report = function(message, error) {
    var ref4, ref3;
    return (ref4 = getErrorReporter()) === null || ref4 === void 0 ? void 0 : ref4.report(new Error("".concat(message, ". ").concat((ref = (ref3 = error) === null || ref3 === void 0 ? void 0 : ref3.message) !== null && ref !== void 0 ? ref : error)));
};
